import FloatingText from '@sport1/react-elements/FloatingText'
export default FloatingText
